import { atom } from "recoil";
import { RecoilKeys } from "../../common/miscellaneous/RecoilKeys";

export const companiesAtom = atom<any>({
    key: RecoilKeys.Companies,
    default: [],
  });